import { FC, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import Modal from '../Modal/modal';
import ThemePicker from '../ThemePicker';
import styles from './settings-modal.module.scss';

interface SettingsModalProps {
  onClose: () => void;
}

/**
 * Mounted only while open, so its controls never sit invisibly in the tab
 * order. Focus moves to the selected theme on open; the caller restores it.
 */
const SettingsModal: FC<SettingsModalProps> = ({ onClose }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    contentRef.current
      ?.querySelector<HTMLInputElement>('input:checked')
      ?.focus({ preventScroll: true });
  }, []);

  return createPortal(
    <Modal title="Settings" isOpen={true} onClose={onClose}>
      <div ref={contentRef} className={styles['settings']}>
        <section aria-labelledby="settings-appearance">
          <h3 id="settings-appearance">Appearance</h3>
          <p>Choose how GANNET looks in this browser.</p>
          <ThemePicker />
        </section>
      </div>
    </Modal>,
    document.body
  );
};

export default SettingsModal;
